// 🎯 Adaptador de API para carritos - API adapter for carts
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

export interface CartResponse {
  id: number;
  code: string;
  name?: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CartApiResponse {
  data: CartResponse[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
  };
  links: {
    first: string;
    prev: string | null;
    next: string | null;
    last: string;
  };
}

export class CartApiAdapter {
  private httpClient: ReturnType<typeof createHttpClient>;

  constructor(httpClient: ReturnType<typeof createHttpClient>) {
    this.httpClient = httpClient;
  }

  // 🎯 Obtener carritos por IDs
  async getCartsByIds(ids: string): Promise<CartApiResponse> {
    try {
      const response = await this.httpClient.get<CartApiResponse>('/carts', {
        ids: ids,
      });
      return response;
    } catch (error: any) {
      console.log('🔍 CartApiAdapter - Error al obtener carritos:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Obtener un carrito por ID
  async getCartById(id: number): Promise<CartResponse> {
    try {
      const response = await this.httpClient.get<CartResponse>(`/carts/${id}`);
      return response;
    } catch (error: any) {
      console.log('🔍 CartApiAdapter - Error al obtener carrito:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }
}
